import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { PUBLIC_SITE_ORIGIN } from "@/lib/public-origin";
import { DICTS } from "@/lib/i18n";

export const Route = createFileRoute("/account/ambassador")({
  component: lazyRouteComponent(() => import("./-pages/account.ambassador")),
  head: () => {
    const title = DICTS.en["account.ambassador.title"] ?? "Ambassador Program — Lecmo";
    const description =
      DICTS.en["account.ambassador.subtitle"] ??
      "Become a Lecmo ambassador. Your link, your earnings, your network.";
    const image = `${PUBLIC_SITE_ORIGIN}/og/ambassador.jpg`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:image", content: image },
        { property: "og:image:width", content: "1216" },
        { property: "og:image:height", content: "640" },
        { property: "og:type", content: "website" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:image", content: image },
        { name: "robots", content: "noindex, nofollow" },
      ],
    };
  },
});
